import { type GetterTree } from 'vuex';

import { type ITagListByLeadState } from './types';

export const GET_FROM_LEAD = 'getFromLead';

export const getters: GetterTree<ITagListByLeadState, unknown> = {
    [GET_FROM_LEAD]: (_state: ITagListByLeadState) => {
        return (leadId: number): number[] | undefined => {
            if (leadId !== undefined) {
                return _state.tagListByLead.get(leadId);
            }
        };
    }
};
